import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import CertCard from "./CertCard";
import { certsForCareer, certsForCareers, type Certification } from "@/lib/certifications";

/**
 * Certifications mapped to one career (ciId) or to a learner's matches (ciIds).
 * Renders nothing when there is no mapping.
 */
export default function RecommendedCerts({
  ciId, ciIds, recommended = false, limit = 6, showAllLink = true,
}: { ciId?: string; ciIds?: string[]; recommended?: boolean; limit?: number; showAllLink?: boolean }) {
  const location = useLocation();
  const [certs, setCerts] = useState<Certification[] | null>(null);
  const key = ciId ?? (ciIds ?? []).join(",");

  useEffect(() => {
    let live = true;
    const p = ciId ? certsForCareer(ciId, limit) : certsForCareers(ciIds ?? [], limit);
    p.then((c) => live && setCerts(c)).catch(() => live && setCerts([]));
    return () => { live = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, limit]);

  if (!certs?.length) return null;
  return (
    <div className="space-y-3">
      <ul className="grid gap-3 sm:grid-cols-2">
        {certs.map((c) => (
          <CertCard key={c.id} cert={c} recommended={recommended} from={location.pathname} />
        ))}
      </ul>
      {showAllLink && (
        <Link to="/certifications" className="inline-flex min-h-11 items-center text-sm font-medium text-primary underline-offset-4 hover:underline">
          Browse all NSDC-approved certifications
        </Link>
      )}
    </div>
  );
}
